import React from 'react';
import {
  LlamaBarChart,
  LlamaDocument,
  LlamaFoot,
  LlamaFile,
  LlamaFlag,
  LlamaGear,
  LlamaGraduationCap,
  LlamaHome,
  LlamaHook,
  LlamaLegal,
  LlamaLogout,
  LlamaProfile,
  LlamaPuzzle,
  LlamaQuestion,
  LlamaSearch,
  LlamaSettings,
  LlamaSwitchAccount,
  LlamaUsersMultiple,
  LlamaVirgilHr,
} from '@easyllama/ui-components/icons';

/** Use `el:*` so classes sit in the same cascade as @easyllama/ui-components (nav revert-layer). */
const SIDEBAR_ICON_CLASS = 'el:size-6';
const SIDEBAR_TOGGLE_ICON_CLASS = 'el:size-6';

function mapIconKey(item, navigationVariant = 'default') {
  if (item?.icon) return item.icon;

  const title = String(item?.title || '').toLowerCase();
  const normalizedTitle = title
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const learnersIconMap = {
    'home': 'home',
    'my courses': 'my-training',
    'my learning journeys': 'journeys',
    'anonymous reporting': 'case',
    'training library': 'my-training',
    'documents and policies': 'documents',
    'resources': 'resources',
    'settings': 'settings-gear',
    'admin view': 'admin-view',
    'help': 'help',
    'why easyllama': 'journeys',
    'the platform': 'case',
    'request proposal': 'documents',
  };

  if (navigationVariant === 'learners') {
    return learnersIconMap[normalizedTitle] || undefined;
  }

  const defaultIconMap = {
    'learners': 'learners',
    'groups': 'learners',
    'my trainings': 'my-training',
    'my training': 'my-training',
    'trainings': 'training',
    'training': 'training',
    'insights and reports': 'insights',
    'phishing simulator': 'phishing',
    'compliance advisor': 'compliance',
    'document manager': 'document-manager',
    'case management': 'case',
    'search': 'search',
    'settings': 'settings',
    'help': 'help',
    'virgilhr': 'virgil-hr',
    'switch account': 'switch-account',
    'log out': 'logout',
    'logout': 'logout',
  };

  return defaultIconMap[normalizedTitle] || undefined;
}

function resolveUiDashboardIcon(iconKey) {
  const key = String(iconKey || '').toLowerCase().trim();
  switch (key) {
    case 'home':
      return <LlamaHome className={SIDEBAR_ICON_CLASS} />;
    case 'learners':
      return <LlamaUsersMultiple className={SIDEBAR_ICON_CLASS} />;
    case 'journeys':
      return <LlamaFoot className={SIDEBAR_ICON_CLASS} />;
    case 'training':
      return <LlamaPuzzle className={SIDEBAR_ICON_CLASS} />;
    case 'documents':
      return <LlamaFile className={SIDEBAR_ICON_CLASS} />;
    case 'document-manager':
      return <LlamaDocument className={SIDEBAR_ICON_CLASS} />;
    case 'virgil-hr':
      return <LlamaVirgilHr className={SIDEBAR_ICON_CLASS} />;
    case 'resources':
      return <LlamaPuzzle className={SIDEBAR_ICON_CLASS} />;
    case 'insights':
      return <LlamaBarChart className={SIDEBAR_ICON_CLASS} />;
    case 'phishing':
      return <LlamaHook className={SIDEBAR_ICON_CLASS} />;
    case 'compliance':
      return <LlamaLegal className={SIDEBAR_ICON_CLASS} />;
    case 'case':
      return <LlamaFlag className={SIDEBAR_ICON_CLASS} />;
    case 'search':
      return <LlamaSearch className={SIDEBAR_ICON_CLASS} />;
    case 'settings':
      return <LlamaSettings className={SIDEBAR_ICON_CLASS} />;
    case 'settings-gear':
      return <LlamaGear className={SIDEBAR_ICON_CLASS} />;
    case 'help':
      return <LlamaQuestion className={SIDEBAR_ICON_CLASS} />;
    case 'admin-view':
      return <LlamaProfile className={SIDEBAR_ICON_CLASS} />;
    case 'my-training':
      return <LlamaGraduationCap className={SIDEBAR_ICON_CLASS} />;
    case 'switch-account':
      return <LlamaSwitchAccount className={SIDEBAR_ICON_CLASS} />;
    case 'logout':
      return <LlamaLogout className={SIDEBAR_ICON_CLASS} />;
    default:
      return undefined;
  }
}

export { SIDEBAR_ICON_CLASS, SIDEBAR_TOGGLE_ICON_CLASS, mapIconKey, resolveUiDashboardIcon };
